import { sandboxEchoPageEntryPoint } from '@jira/spa-apps__sandbox-relay/src/sandboxEchoPageEntryPoint.entrypoint.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { sandboxRelayEchoPageUsingEntryPointRoute } from '@jira/router-routes__sandbox-routes/src/sandboxRelayEchoPageUsingEntryPointRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const sandboxRelayEchoPageEntryPoint = createPageEntryPoint({
	main: sandboxEchoPageEntryPoint,
});

export const sandboxRelayEchoPageUsingEntryPointRouteEntry: Route = createEntry(
	sandboxRelayEchoPageUsingEntryPointRoute,
	() => ({
		group: 'sandbox',
		entryPoint: () => sandboxRelayEchoPageEntryPoint,
		layout: globalLayout,
		resources: [],
		ufoName: 'sandbox-relay-echo',

		bifrost: {
			// WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
			// manifestName: 'jira-spa-sandboxdemo.json',
			bifrostGroup: 'not-deployed',
		},
	}),
);
